export default __webpack_public_path__ + "static/media/Pratima Sonavane.a67b2c92.jpg";